export let weekRangeSameMonthStart_dMy = "GZeRYb";
export let weekRangeSameMonthEnd_dMy = "XpEfBe";
export let weekRangeSameYearStart_dMy = "Hzqc4b";
export let weekRangeSameYearEnd_dMy = "OuYoqb";
export let weekRangeDifferentYearsStart_dMy = "hP8zNb";
export let weekRangeDifferentYearsEnd_dMy = "iDjlxd";
export let weekRangeSameMonthStart_Mdy = "Os0wLb";
export let weekRangeSameMonthEnd_Mdy = "dVnXne";
export let weekRangeSameYearStart_Mdy = "P4$TQb";
export let weekRangeSameYearEnd_Mdy = "WZH6cb";
export let weekRangeDifferentYearsStart_Mdy = "piSfAb";
export let weekRangeDifferentYearsEnd_Mdy = "q842jd";
export let weekRangeSameMonthStart_ydM = "GErc$b";
export let weekRangeSameMonthEnd_ydM = "X6QCNe";
export let weekRangeSameYearStart_ydM = "HeDzec";
export let weekRangeSameYearEnd_ydM = "O$_LCb";
export let weekRangeDifferentYearsStart_ydM = "hujXZb";
export let weekRangeDifferentYearsEnd_ydM = "iiwIJd";
export let weekRangeSameMonthStart_yMd = "M6C7_b";
export let weekRangeSameMonthEnd_yMd = "bx2vNe";
export let weekRangeSameYearStart_yMd = "NGOsec";
export let weekRangeSameYearEnd_yMd = "UBkFCb";
export let weekRangeDifferentYearsStart_yMd = "nWuQZb";
export let weekRangeDifferentYearsEnd_yMd = "oKHBJd";
export let weekRangeStartEnd = "IG7q_b";
export let weekRangeWeekNumber = "kkYhuc";
export let calendarMonthStandalone_January = "SP3XRd";
export let calendarMonthStandalone_February = "AG1M8d";
export let calendarMonthStandalone_March = "zl7nKe";
export let calendarMonthStandalone_April = "i5vxzc";
export let calendarMonthStandalone_May = "xrX0ye";
export let calendarMonthStandalone_June = "UcsWre";
export let calendarMonthStandalone_July = "IfSVre";
export let calendarMonthStandalone_August = "hoq1Ne";
export let calendarMonthStandalone_September = "XCukk";
export let calendarMonthStandalone_October = "UhVhbd";
export let calendarMonthStandalone_November = "gMX$L";
export let calendarMonthStandalone_December = "ZpaQHd";
export let amLowercaseShort = "TVAeZd";
export let pmLowercaseShort = "EpuFE";
export let amLowercase = "jAWAuc";
export let pmLowercase = "mmX6xc";
export let amUppercaseShort = "mFjcrb";
export let pmUppercaseShort = "tUh3Rc";
export let amUppercase = "OD5Zrd";
export let pmUppercase = "Rp6tvd";
export let minute = "iIoCDc";
export let minuteShort = "o35fYc";
export let minuteLetter = "YCtk_b";
export let userDateTimeFormat = "BZ_Zpc";
export let monthDayFormatDayFirst = "t_05db";
export let monthDayFormatMonthFirst = "luly5";
export let monthDayWeekDayFormatDayFirst = "X5jLfb";
export let monthDayWeekDayFormatMonthFirst = "j$0sGe";
export let MMMM = "Mx5KR";
export let monthDayYearFormat = "UJz90b";
export let yyyy = "_sJEeb";
export let H = "sba";
export let MMM = "XQ4sT";
export let d = "Uba";
export let MM = "OK1w";
export let dd = "AjQD";
export let dayWeekDayFormat = "tiO7he";
export let hT = "ue2E";
export let Th = "SC6y";
export let timeSeparator = "iyDHpd";
export let shortWeekDayMonthDayYearFormat = "YFVLMe";
export let weekDayDateTimeFormat = "YSkZ1d";
export let weekDayDateTimeWithAtFormat = "xk1S$d";
export let weekDayMonthDayFormat = "zdMRV";
export let weekDayMonthDayYearFormat = "_wK4ld";
export let weekDayTimeFormat = "_uDDVb";
export let yearMonthFormatYearFirst = "vwFbud";
export let yearMonthFormatMonthFirst = "CvhRJe";
export let M = "xba";
export let yy = "GW4J";
export let h = "Yba";
export let hh = "Oe2E";
export let HH = "KQwv";
export let m = "bca";
export let mm = "S_uG";
export let oneMinuteAgoText = "s$v1Hc";
export let minutesAgoText = "tMWktb";
export let yesterdayTime = "VWyh7d";
export let weekdayAtTime = "CcRb9";
export let oneHourAgoText = "UDO7Md";
export let hoursAgoText = "BY__Kb";
export let oneDayAgoText = "kXtv1";
export let daysAgoText = "hKc4Cc";
export let oneWeekAgoText = "Q7bD6";
export let weeksAgoText = "Zwk_hb";
export let oneMonthAgoText = "qctijd";
export let monthsAgoText = "XluTec";
export let oneYearAgoText = "fLz7U";
export let yearsAgoText = "OueDNb";
export let singleDateFormat_dMy = "_pTRAc";
export let singleDateFormat_Mdy = "gVCxnc";
export let singleDateFormat_ydM = "_65cNc";
export let singleDateFormat_yMd = "exf8Mc";
export let singleDateShortMonthFormat_dMy = "wctBMe";
export let singleDateShortMonthFormat_Mdy = "EHchze";
export let singleDateShortMonthFormat_ydM = "a_Ayd";
export let singleDateShortMonthFormat_yMd = "gAMrd";
export let singleDateUseWeekDayFormat = "eViGNc";
export default {weekRangeSameMonthStart_dMy,weekRangeSameMonthEnd_dMy,weekRangeSameYearStart_dMy,weekRangeSameYearEnd_dMy,weekRangeDifferentYearsStart_dMy,weekRangeDifferentYearsEnd_dMy,weekRangeSameMonthStart_Mdy,weekRangeSameMonthEnd_Mdy,weekRangeSameYearStart_Mdy,weekRangeSameYearEnd_Mdy,weekRangeDifferentYearsStart_Mdy,weekRangeDifferentYearsEnd_Mdy,weekRangeSameMonthStart_ydM,weekRangeSameMonthEnd_ydM,weekRangeSameYearStart_ydM,weekRangeSameYearEnd_ydM,weekRangeDifferentYearsStart_ydM,weekRangeDifferentYearsEnd_ydM,weekRangeSameMonthStart_yMd,weekRangeSameMonthEnd_yMd,weekRangeSameYearStart_yMd,weekRangeSameYearEnd_yMd,weekRangeDifferentYearsStart_yMd,weekRangeDifferentYearsEnd_yMd,weekRangeStartEnd,weekRangeWeekNumber,calendarMonthStandalone_January,calendarMonthStandalone_February,calendarMonthStandalone_March,calendarMonthStandalone_April,calendarMonthStandalone_May,calendarMonthStandalone_June,calendarMonthStandalone_July,calendarMonthStandalone_August,calendarMonthStandalone_September,calendarMonthStandalone_October,calendarMonthStandalone_November,calendarMonthStandalone_December,amLowercaseShort,pmLowercaseShort,amLowercase,pmLowercase,amUppercaseShort,pmUppercaseShort,amUppercase,pmUppercase,minute,minuteShort,minuteLetter,userDateTimeFormat,monthDayFormatDayFirst,monthDayFormatMonthFirst,monthDayWeekDayFormatDayFirst,monthDayWeekDayFormatMonthFirst,MMMM,monthDayYearFormat,yyyy,H,MMM,d,MM,dd,dayWeekDayFormat,hT,Th,timeSeparator,shortWeekDayMonthDayYearFormat,weekDayDateTimeFormat,weekDayDateTimeWithAtFormat,weekDayMonthDayFormat,weekDayMonthDayYearFormat,weekDayTimeFormat,yearMonthFormatYearFirst,yearMonthFormatMonthFirst,M,yy,h,hh,HH,m,mm,oneMinuteAgoText,minutesAgoText,yesterdayTime,weekdayAtTime,oneHourAgoText,hoursAgoText,oneDayAgoText,daysAgoText,oneWeekAgoText,weeksAgoText,oneMonthAgoText,monthsAgoText,oneYearAgoText,yearsAgoText,singleDateFormat_dMy,singleDateFormat_Mdy,singleDateFormat_ydM,singleDateFormat_yMd,singleDateShortMonthFormat_dMy,singleDateShortMonthFormat_Mdy,singleDateShortMonthFormat_ydM,singleDateShortMonthFormat_yMd,singleDateUseWeekDayFormat};